import { Instance, SnapshotIn, SnapshotOut, flow, types } from 'mobx-state-tree';

import {
	getCgCounselor,
	getCgCounselorProducts,
	removeCgCounselor,
	saveCgCounselor,
} from '@common/api/cgCounselors';
import { deleteMedia } from '@common/api/media';
import handleApiErrors from '@common/helpers/handleApiErrors';
import User from '@common/models/Users/User';

const CgCounselorModel = types
	.compose(
		User,
		types.model({
			phone: types.maybeNull(types.string),
			position: types.maybeNull(types.string),
			personal_number: types.maybeNull(types.string),
			zoom_link: types.maybeNull(types.string),
			zoom_id: types.maybeNull(types.string),
			zoom_access_code: types.maybeNull(types.string),
			zoom_on_off: types.maybeNull(types.number),
			miro_link: types.maybeNull(types.string),
			job_title: types.maybeNull(types.string),
			can_impersonate: types.maybeNull(types.boolean),
			user: types.maybe(types.frozen()),
			tags: types.optional(types.array(types.string), []),
		}),
	)
	.named('CgCounselor')
	.actions(() => ({
		_fetch: getCgCounselor,
		_save: saveCgCounselor,
		_remove: removeCgCounselor,
	}))
	.actions((self) => ({
		deleteAvatar: flow(function* () {
			yield deleteMedia({
				id: self.user_id as number,
				entity: 'users',
				media_collection: 'avatar',
			});
			yield self._fetch(self.id);
		}),

		getProducts: flow(function* (id) {
			self.loading = true;
			try {
				const result = yield getCgCounselorProducts(id || self.id);
				// applySnapshot(self, result);
				return result;
			} catch (e) {
				handleApiErrors(e);
			} finally {
				self.loading = false;
			}
		}),
	}));

export default CgCounselorModel;

export type ICgCounselorModelInstance = Instance<typeof CgCounselorModel>;
export type ICgCounselorModelSnapshotIn = SnapshotIn<typeof CgCounselorModel>;
export type ICgCounselorModelSnapshotOut = SnapshotOut<typeof CgCounselorModel>;
